import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import MrBee from '../game/MrBee';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import { dotPop } from '../Utilities';
import BonusScreen from './BonusScreen';
import Game from './Game';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class ResultsScreen extends Phaser.Scene {
  static get KEY() { return 'ResultsScreen'; }

  constructor() {
    super({ key: ResultsScreen.KEY });
  }

  init() {
    this.mrbee = null;

    this.resultType = 'QUESTIONS';
    this.titleContainer = null;
    this.scoreContainer = null;
    this.lblSubtitle = null;
    this.feedbackContainer = null;

    this.subtext = null;

    this.resultType = 'QUESTIONS';

    this.btnGo = null;
    this.btnLabel = null;

    this.score = 0;

    this.nextSceneKey = null;

    this.beeIdleTime = 0;
    this.beeIdleWaitTime = 6000;
    this.showingResults = true;
  }

  create(data) {
    if (!data?.resultType) {
      // this can be used to set the result type for testing purposes, and also set dummy data
      this.resultType = 'FINAL';// "QUESTIONS", "BONUS", "FINAL"

      gameData.gameInfo.currentRound = 2;
      gameData.gameInfo.playedInstructions = true;

      gameData.userData.roundResults = [
        createDummyRoundData(10,0),
        createDummyRoundData(2,8),
        createDummyRoundData(9,1),
      ];

      gameData.userData.bonusResults = {
        bonusType: 'Even',
        score: 80,
        wrongPops: [1,3]
      };
    }
    else this.resultType = data.resultType;

    this.bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._MainBackground, this).setOrigin(0);

    this.titleContainer = this.add.container();
    this.scoreContainer = this.add.container();
    this.feedbackContainer = this.add.container();

    let sn = '';
    if (this.resultType === 'QUESTIONS') {
      this.tmpQuestions = [];
      const d = gameData.userData.roundResults[gameData.gameInfo.currentRound - 1].questionResults;
      for (let i = 0; i < d.length; i++) {
        if (d[i].attempts > 1) {
          this.tmpQuestions.push(d[i].questionString);
        }
      }
      if (gameData.userData.roundResults[gameData.gameInfo.currentRound - 1].incorrectCount === 0) {
        this.score = 100;
      }
      else {
        this.score = (gameData.userData.roundResults[gameData.gameInfo.currentRound - 1].totalCount - gameData.userData.roundResults[gameData.gameInfo.currentRound - 1].incorrectCount) / gameData.userData.roundResults[gameData.gameInfo.currentRound - 1].totalCount;
        this.score = this.score * 100;
      }
      if (this.score >= 70) {
        sn = UIAssetKeys._Label_GoBonusRound; ;
        this.nextSceneKey = BonusScreen.KEY;
      }
      else {
        sn = UIAssetKeys._Label_GoTryAgain;
        this.nextSceneKey = Game.KEY;
      }
      this.createRoundResults();
      const snd = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      snd.once(Phaser.Sound.Events.COMPLETE, this.sayScoreResult, this);
      snd.once(Phaser.Sound.Events.COMPLETE, () => snd.destroy());
      ABCyaPhaser.Audio.playSound(`vo_round_${gameData.gameInfo.currentRound}_results`, snd);

      this.subtext = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Label_ResultsBonusRound, this).setOrigin(0);
      this.subtext.x = this.scale.width / 2 - this.subtext.width / 2;
      this.subtext.y = this.scale.height - this.subtext.height - 13;
    }
    else if (this.resultType === 'BONUS') {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._vo_bonus_result, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      this.score = gameData.userData.bonusResults.score;
      this.score = Math.floor(this.score);
      if (gameData.gameInfo.currentRound <= 3) {
        sn = UIAssetKeys._Label_NextRound;
        this.nextSceneKey = Game.KEY;
      }
      else {
        sn = UIAssetKeys._Label_FinalResultsButton;
        this.nextSceneKey = ResultsScreen.KEY;
      }

      this.createBonusResults();
    }
    else if (this.resultType === 'FINAL') {
      sn = UIAssetKeys._Label_PlayAgain;

      const len = gameData.userData.roundResults.length;
      let t = 0;
      let w = 0;
      this.tmpQuestions = [];
      for (let i = 0; i < len; i++) {
        const d = gameData.userData.roundResults[i].questionResults;
        for (let q = 0; q < d.length; q++) {
          if (d[q].attempts > 1) {
            this.tmpQuestions.push(d[q].questionString);
          }
        }
        t += gameData.userData.roundResults[i].totalCount;
        w += gameData.userData.roundResults[i].incorrectCount;
      }
      if (w === 0) {
        this.score = 100;
      }
      else {
        this.score = ((t - w) / t) * 100;
      }
      this.score = Math.floor(this.score);
      this.nextSceneKey = Game.KEY;
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._vo_you_finished_all, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      this.createFinalResults();
    }

    this.titleContainer.x = this.scale.width / 2 - this.titleContainer.getBounds().width / 2;
    this.titleContainer.y = -50;

    this.scoreContainer.x = this.scale.width / 2;
    this.scoreContainer.y = 222;
    if (this.score === 100) this.scoreContainer.y += 38;
    const scoreContainerBounds = this.scoreContainer.getBounds();
    this.scoreContainer.list.forEach((child) => {
      child.setPosition(child.x - scoreContainerBounds.width / 2, child.y - scoreContainerBounds.height / 2);
    });
    this.scoreContainer.scale = 0;

    this.feedbackContainer.x = this.scale.width;
    this.feedbackContainer.y = 360;

    this.btnGo = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BtnGoAlt, this).setInteractive()
      .setScale(0);
    this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickGo, this);
    this.btnGo.x = this.scale.width / 2;
    const os = 180;
    this.btnGo.y = this.scale.height - os;

    this.btnLabel = ABCyaPhaser.Images.addImage(this.btnGo.x,this.scale.height + 80,sn, this);

    this.startShowing();
  }

  createRoundResults () {
    const spacer = 15;
    const lblround = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._Header_Round, this.titleContainer).setOrigin(0);
    const rndNum = ABCyaPhaser.Text.addText(0,-8,gameData.fontSizes.lg, 0xffffff, FontKeys._asapbold, gameData.gameInfo.currentRound, this.titleContainer).setOrigin(0)
      .setScale(0.45);
    const lblresults = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Header_Results, this.titleContainer).setOrigin(0);
    rndNum.x = lblround.width + spacer;
    lblresults.x = rndNum.x + rndNum.width * rndNum.scaleX + spacer;

    this.createScoreCircle();

    this.createIncorrectList();
  }

  createScoreCircle () {
    const rad = this.score === 100 ? 126 : 110;
    const stroke = 10;
    const circle = this.add.circle(0,0,rad,0xffffff, 0).setStrokeStyle(stroke, 0xffffff, 1);
    circle.x = rad + stroke / 2;
    circle.y = rad + stroke / 2;

    this.scoreContainer.add(circle);

    const txtscore = ABCyaPhaser.Text.addText(0,0,gameData.fontSizes.lg, 0xffffff, FontKeys._asapbold, `${this.score}%`, this.scoreContainer).setOrigin(0);
    txtscore.x = rad - txtscore.width / 2 + stroke;
    txtscore.y = rad - txtscore.height / 2 + stroke;

    this.scoreContainer.workingWidth = rad * 2 + stroke / 2;
    this.scoreContainer.workingHeight = rad * 2 + stroke / 2;
  }

  createIncorrectList () {
    const len = this.tmpQuestions.length;
    if (len <= 0) return;
    const title = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Header_IncorrectAnswers, this.feedbackContainer).setOrigin(0);

    const c2 = this.add.container();
    let sp = null; let row = 0; let col = 0;
    let rowcnt = 2;
    if (this.tmpQuestions.length >= 20) rowcnt = 11;
    let maxwidth = 0;
    for (let i = 0; i < len; i++) {
      row = i % rowcnt;
      col = Math.floor(i / rowcnt);
      sp = ABCyaPhaser.Text.addText(row * 80, col * 25, gameData.fontSizes.sm, 0xffffff, FontKeys._asapmedium, this.tmpQuestions[i], c2).setOrigin(0);
      sp.x = row * 80;
      sp.y = col * 25;
      maxwidth = Math.max(sp.x + sp.width, maxwidth);
    }
    if (title.width > maxwidth) {
      c2.x = title.width / 2 - maxwidth / 2;
    }
    else {
      title.x = maxwidth / 2 - title.width / 2;
    }

    c2.y = title.height + 8;
    this.feedbackContainer.add(c2);
  }

  sayScoreResult () {
    if (this.score >= 70) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._vo_play_bonus_round, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
    else {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._vo_no_bonus_round, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
  }

  createBonusResults () {
    const spacer = 15;
    const lblround = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Header_Bonus, this.titleContainer).setOrigin(0);
    const lblresults = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Header_Results, this.titleContainer).setOrigin(0);
    lblresults.x = lblround.x + lblround.width * lblround.scaleX + spacer;

    this.createScoreCircle();

    this.createWrongPopList();
  }

  createWrongPopList () {
    if (gameData.userData.bonusResults.wrongPops.length <= 0) return;
    const title = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Header_WrongGuesses, this.feedbackContainer).setOrigin(0);
    const subtitle = ABCyaPhaser.Images.addImage(0,0,`Wrong_${gameData.userData.bonusResults.bonusType}`, this.feedbackContainer).setOrigin(0);
    title.x = subtitle.width / 2 - title.width / 2;
    subtitle.y = title.height + 8;
    const str = gameData.userData.bonusResults.wrongPops.sort().join(', ');
    const wrongtxt = ABCyaPhaser.Text.addText(0,0,gameData.fontSizes.sm, 0xffffff, FontKeys._asapmedium, str, this.feedbackContainer).setOrigin(0);
    wrongtxt.x = subtitle.width / 2 - wrongtxt.width / 2;
    wrongtxt.y = subtitle.y + subtitle.height + 10;
  }

  createFinalResults () {
    const spacer = 15;
    const lblround = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Header_Final, this.titleContainer).setOrigin(0);
    const lblresults = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Header_Results, this.titleContainer).setOrigin(0);
    lblresults.x = lblround.x + lblround.width * lblround.scaleX + spacer;

    const lblSub = ABCyaPhaser.Images.addImage(0,40,UIAssetKeys._Label_FinalResultsSubtitle, this).setOrigin(0);
    lblSub.x = this.titleContainer.getBounds().width / 2 - lblSub.width / 2;
    this.titleContainer.add(lblSub);

    this.createScoreCircle();
    this.createIncorrectList();
  }

  startShowing () {
    this.initBee();
    const y = 40;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._boing, this);
    ABCyaPhaser.Tweens.addTween(this.titleContainer, 620, { y }, Phaser.Math.Easing.Bounce.Out, () => this.showScore());
  }

  showScore () {
    ABCyaPhaser.Tweens.addTween(this.scoreContainer,240, { scale: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.scoreContainer,320, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.showFeedback();
      });
    });
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._boing, this);
  }

  showFeedback () {
    if (this.score === 100) {
      this.showGo();
      return;
    }
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._boing, this);
    ABCyaPhaser.Tweens.addTween(this.feedbackContainer, 640, { x: this.scale.width / 2 - this.feedbackContainer.getBounds().width / 2 }, Phaser.Math.Easing.Bounce.Out, () => {
      this.showGo();
    });
  }

  showGo () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._boing, this);
    dotPop(this.btnGo);
    const os = 80;
    ABCyaPhaser.Tweens.addTween(this.btnLabel, 600, { delay: 300, y: this.btnGo.y + os }, Phaser.Math.Easing.Bounce.Out);
  }

  clickGo () {
    this.showingResults = false;
    ABCyaPhaser.Tweens.addTween(this.btnLabel, 440, { y: this.scale.height + 150 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.feedbackContainer, 440, { x: this.scale.width + 600 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.scoreContainer, 440, { scale: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.btnGo, 440, { scale: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.titleContainer, 440, { y: -200 }, Phaser.Math.Easing.Linear);

    this.mrbee.beeIdleTime = 0;
    this.mrbee.beeIdleWaitTime = 100000;
    this.mrbee.initMoveTo(this.scale.width + 600, this.mrbee.pos.y + Phaser.Math.Between(1,60), 60);
    this.time.delayedCall(650, this.nextScene, null, this);
  }

  nextScene () {
    this.sound.stopAll();
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    if (gameData.gameInfo.currentRound > 3) gameData.gameInfo.currentRound = 1;
    if (this.nextSceneKey === ResultsScreen.KEY) this.scene.start(this.nextSceneKey, { resultType: 'FINAL' });
    else this.scene.start(this.nextSceneKey);
  }

  initBee () {
    this.mrbee = new MrBee(this, false);
    const mrBeeBounds = this.mrbee.getBounds();
    this.mrbee.list.forEach((child) => {
      child.setPosition(child.x - mrBeeBounds.width / 2, child.y - mrBeeBounds.height / 2);
    });
    const x = -50;
    const y = 380;
    this.mrbee.pos.x = x;
    this.mrbee.pos.y = y;
    this.mrbee.initForceMove(100,y - Phaser.Math.Between(10,22));
    this.mrbee.x = x;
    this.mrbee.y = y;
    this.mrbee.turn(-1);
    this.add.existing(this.mrbee);
  }

  update (time,delta) {
    const deltaSeconds = delta / 1000;
    if (this.mrbee) this.mrbee.tick(deltaSeconds);
    if (this.showingResults) {
      if (this.beeIdleTime > this.beeIdleWaitTime) {
        let x = Phaser.Math.Between(10, 200) - 100;
        let y = Phaser.Math.Between(10, 200) - 100;
        x = x + this.mrbee.pos.x;
        y = y + this.mrbee.pos.y;
        if (x < 100) x = 100;
        if (y < 100) y = 100;
        if (x > this.scale.width - 100) x = this.scale.width - 100;
        if (y > this.scale.height - 150) y = this.scale.height - 150;
        this.mrbee.initForceMove(x,y);
        if (x - this.mrbee.pos.x > 0) {
          this.mrbee.turn(-1);
        }
        else {
          this.mrbee.turn(1);
        }
        this.beeIdleTime = 0;
      }
      else {
        this.beeIdleTime += delta;
      }
    }
  }
}

function createDummyRoundData(correct, incorrect) {
  const results = { incorrectCount: incorrect, totalCount: correct + incorrect , questionResults: [] };
  for (let i = 0; i < incorrect; i++) {
    results.questionResults.push({ attempts: Phaser.Math.Between(2,4), questionString: `${i * 2}-${i}=${i}` });
  }
  for (let i = 0; i < correct; i++) {
    results.questionResults.push({ attempts: 1, questionString: `${i * 2}-${i}=${i}` });
  }
  return results;
}